import React, { HTMLAttributes } from "react";
import useReceiptStore from "../../../store/receipt";

interface IReceiptParkingCard {}

type TReceiptParkingCardProps = IReceiptParkingCard &
  HTMLAttributes<HTMLDivElement>;

const ReceiptParkingCard: React.FC<TReceiptParkingCardProps> = (props) => {
  const { ...otherProps } = props;
  const { receiptParkingList, selectedId } = useReceiptStore((state) => state);

  const currentParkingInfo = receiptParkingList.find(
    (parking) => parking.parking_id === selectedId
  );

  if (!currentParkingInfo) return null;
  return (
    <div className="relative flex flex-row group border border-white rounded-lg p-3 gap-4">
      {/* cover */}
      <img
        className="rounded-lg aspect-video w-[120px]"
        src={currentParkingInfo.parking.cover}
        alt={currentParkingInfo.parking.display_name}
      />

      <div className="flex flex-row flex-1 gap-2 justify-between mt-2">
        <div className="flex flex-col flex-1 gap-1 text-sm">
          <div className="min-w-8 text-center font-medium text-black rounded px-2 py-1 bg-mainYellow w-fit">
            {currentParkingInfo.parking.name}
          </div>
          <div className="text-white ">
            {currentParkingInfo.parking.location}
          </div>
          <div className="text-white">
            {currentParkingInfo.parking.location_en}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptParkingCard;
